const styles = {
  backgroundBg: '#04061e',
  moduleBg: '#171a42',
  galaxyPurpleLight: '#51286a',
  skyBlue: '#167c99',
  suiBlue: '#75b7ea'
}

export default styles
